import React from 'react'
import { ReactComponent as LeadIcon } from '../../../images/sold_vehicle_path/lead_icon.svg'
import dayjs from 'dayjs'
import { ReactComponent as PerformanceCPUserPathEnd } from '../../../images/performance/performance-cp-user-end.svg'

type SalesEventStepProps = {
  Title: string
  Time: Date | string
  VIN?: string
  Vehicle?: string
}

export default function SalesEventStep({
  industry = 'automotive',
  path,
}: {
  industry?: 'automotive' | 'retail'
  path: SalesEventStepProps
}): JSX.Element {
  if (industry === 'automotive') {
    return (
      <div className="p-3 rounded-2xl flex-col gap-2 w-80 h-80 flex border-2 bg-tea-green border-green-primary">
        <div className={'flex w-full items-center flex-col gap-2'}>
          <PerformanceCPUserPathEnd />

          <div className={'mx-auto text-center'}>
            <h3 className="font-bold text-sm text-green-primary">{path.Title}!</h3>
            <h4 className="font-regular text-xs text-green-primary">
              {dayjs(path.Time).format('MMM DD, YYYY')}
            </h4>
          </div>
          <div className="font-bold text-xs rounded-sm p-2 flex flex-row gap-2 items-center w-full line-clamp-1 bg-green-primary/20 text-green-primary">
            VIN: {path.VIN}
          </div>
          <div className="font-bold text-xs rounded-sm p-2 flex flex-row gap-2 items-center w-full line-clamp-1 bg-green-primary/20 text-green-primary">
            Vehicle: {path.Vehicle}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={
        'py-3 px-4 rounded-2xl flex-col gap-2 min-w-60 h-80 flex border-2 bg-primary-purple/30 border-primary-purple'
      }>
      <div className={'flex w-full items-center flex-col gap-2'}>
        <LeadIcon />
        <div className={'mx-auto text-center'}>
          <h3 className={'font-bold text-md text-primary-purple'}>{path.Title}!</h3>
          <h4 className={'font-regular text-xs text-primary-purple font-medium'}>
            {dayjs(path?.Time).format('MMM D, YYYY - HH:mm:ss')}
          </h4>
        </div>
      </div>
      {path.VIN && (
        <div className="border-t-2 border-primary-purple/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <div className="flex flex-col gap-1 text-primary-purple">
              <span className="font-bold text-sm uppercase">VIN</span>
              <span className="font-semibold text-xs">{path.VIN}</span>
            </div>
          </div>
        </div>
      )}
      {path.Vehicle && (
        <div className="border-t-2 border-primary-purple/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <div className="flex flex-col gap-1 text-primary-purple">
              <span className="font-bold text-sm uppercase">Vehicle</span>
              <span className="font-semibold text-xs">{path.Vehicle}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
